import { put, call, all, fork, select, takeLatest } from "redux-saga/effects";
import { logsApiUpsellProvider } from "../../lib/api/providers";
import {
  LOG_SET_FILTERS,
  LOG_FILTERS_LOADING,
  LOG_SET_LOGS,
  LOG_LOGS_LOADING,
  LOG_SET_PAGINATION,
  LOG_SET_CURRENT_FILTERS,
  LOG_GET_DYNAMIQUE_FILTER_VALUES, //TODO Remove once phototheque is updated
  LOG_SET_SORT,
  LOG_SET_KEY_FILTER_SELECTED
} from "../types";

const getLogState = state => state.log;
const getState = state => state;

const getFiltersValuesApi = state => {
  const currentFiltersToSend = { ...state.currentFilters };
  delete currentFiltersToSend[state.keyFilterSelected];

  if (state.keyFilterSelected === "period") {
    return logsApiUpsellProvider
      .post(`/range/startDate/endDate`, {
        match: currentFiltersToSend
      })
      .then((response = {}) => {
        return response.data;
      });
  } else {
    return logsApiUpsellProvider
      .post(`/distincts/${state.keyFilterSelected}`, {
        match: { ...currentFiltersToSend }
      })
      .then((response = {}) => {
        return response.data;
      });
  }
};

const getLogsApi = async state => {
  const { currentFilters, sort, page, pageSize } = state.log;
  const token = await localStorage.getItem("access_token");
  return logsApiUpsellProvider
    .post(
      `/`,
      {
        match: { ...currentFilters },
        sort: currentFilters.sort ? currentFilters.sort : { created_at: -1 },
        page: page > 0 ? page : 1,
        pageSize: pageSize,
        project: {
          _id: 1,
          created_at: 1,
          user_id: 1,
          version: 1,
          msg: 1,
          title: 1,
          userName: 1
        }
      },
      {
        headers: {
          Authorization: token
        }
      }
    )
    .then((response = {}) => {
      return response.data;
    });
};
function* getLogs() {
  try {
    yield put({ type: LOG_LOGS_LOADING, loading: true });
    const state = yield select(getState);
    const data = yield call(getLogsApi, state);
    if (!Array.isArray(data.docs)) {
      throw new Error("No logs");
    }
    yield put({ type: LOG_SET_LOGS, payload: data });
    yield put({ type: LOG_LOGS_LOADING, loading: false });
  } catch (e) {
    console.log(e.message);
    yield put({ type: LOG_LOGS_LOADING, loading: false });
  }
}

function* getFiltersValues() {
  try {
    yield put({ type: LOG_FILTERS_LOADING, loading: true });
    const state = yield select(getLogState);

    const values = yield call(getFiltersValuesApi, state);

    if (values.length <= 0) {
      throw new Error("No filters");
    }
    yield put({
      type: LOG_SET_FILTERS,
      values: values,
      key: state.keyFilterSelected
    });
    yield put({ type: LOG_FILTERS_LOADING, loading: false });
  } catch (e) {
    console.log(e.message);
    yield put({ type: LOG_FILTERS_LOADING, loading: false });
  }
}

function* watchFecthLogs() {
  yield takeLatest(LOG_SET_CURRENT_FILTERS, getLogs);
}
function* watchFetchLogsPagination() {
  yield takeLatest(LOG_SET_PAGINATION, getLogs);
}
function* wathFetchDynFilterValues() {
  console.log("dyn");
  //TODO Remove once phototheque is updated
  yield takeLatest(LOG_GET_DYNAMIQUE_FILTER_VALUES, getFiltersValues);
}
function* watchSetKeyFilterSelected() {
  console.log("select");
  yield takeLatest(LOG_SET_KEY_FILTER_SELECTED, getFiltersValues);
}

function* watchSortLogs() {
  yield takeLatest(LOG_SET_SORT, getLogs);
}

export default function* root() {
  yield all([
    fork(wathFetchDynFilterValues), //TODO Remove once phototheque is updated
    fork(watchFetchLogsPagination),
    fork(watchFecthLogs),
    fork(watchSortLogs),
    fork(watchSetKeyFilterSelected)
  ]);
}



// WEBPACK FOOTER //
// src/redux/sagas/logsSagas.js